import { render } from "./opay.vue?vue&type=template&id=699c2e0a"
import script from "./opay.vue?vue&type=script&lang=js"
export * from "./opay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__